/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_F5_AInputs */

const en_mk_sec_pg_f5_a = /** @type {(inputs: Mk_Sec_Pg_F5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We treat you as the data controller and ourselves as the processor. A written data processing agreement is available in Enterprise conversations; as a product we have not yet published a standard DPA — see the open ledger above.`)
};

const id_mk_sec_pg_f5_a = /** @type {(inputs: Mk_Sec_Pg_F5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami memperlakukan Anda sebagai pengendali data dan kami sebagai pemroses. Perjanjian pemrosesan data tertulis (DPA) tersedia untuk pembicaraan Enterprise; sebagai produk, DPA standar belum kami terbitkan — lihat daftar terbuka di atas.`)
};

/**
* | output |
* | --- |
* | "We treat you as the data controller and ourselves as the processor. A written data processing agreement is available in Enterprise conversations; as a produc..." |
*
* @param {Mk_Sec_Pg_F5_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_f5_a = /** @type {((inputs?: Mk_Sec_Pg_F5_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_F5_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_f5_a(inputs)
	return en_mk_sec_pg_f5_a(inputs)
});